var Reveals = {

    init: function () {
        $(window).scroll(function () {
            Reveals.scroll();
        });

        $("[init-reveal]").addClass("reveal-top");

        setTimeout(function () {
            $("[init-reveal]").each(function () {
                var _this = $(this);
                if ($(this).attr("data-delay") != undefined) {
                    setTimeout(function () {
                        _this.removeClass("reveal-top").addClass("reveal-visible");
                    }, parseFloat(_this.attr("data-delay")) * 1000);
                } else {
                    $(this).removeClass("reveal-top").addClass("reveal-visible");
                }
            });

        }, 100);

        setTimeout(function () {
            Reveals.scroll();
        }, 40);

    },

    scroll: function () {
        $('[scroll-reveal]').each(function (i, elt) {

            var _margin_b = 0.1;
            var _margin_t = 0.1;

            if ($(this).attr("data-bottom")) {
                _margin_b = parseFloat($(this).attr("data-bottom"));
            }

            if ($(this).attr("data-top")) {
                _margin_t = parseFloat($(this).attr("data-top"));
            }

            var _margin_bottom = $(window).outerHeight() * _margin_b;
            var _margin_top = $(window).outerHeight() * _margin_t;

            var _pos_top = $(this).offset().top - $(window).height() + _margin_bottom;
            var _pos_bottom = ($(this).offset().top + $(this).height()) - _margin_top;
            var _pos_scroll = $(window).scrollTop();


            if (_pos_scroll > _pos_top) {
                if (_pos_scroll < _pos_bottom) {

                    var _delay = 0;
                    var attr = $(this).attr('data-delay');

                    if (typeof attr !== 'undefined' && attr !== false) {
                        _delay = parseFloat($(this).attr('data-delay'));
                    }

                    Reveals.reveal_element($(this), _delay);

                } else {
                    $(this).removeClass("reveal-top reveal-visible").addClass("reveal-bottom");
                }
            } else {
                $(this).removeClass("reveal-visible reveal-bottom").addClass("reveal-top");
            }

        });
    },
    reveal_element: function (target, delay) {
        setTimeout(function () {

            target.removeClass("reveal-bottom reveal-top").addClass("reveal-visible");


            if (target.find("[svgator-player]").length) {
                target.find("[svgator-player]").each(function () {
                    Reveals.play_svg($(this).find("svg").attr("id"));
                });
            }

            if (!target.hasClass("keep-reveal")) {
                target.removeAttr('scroll-reveal');
            }
        }, delay);
    },
    play_svg: function (pID) {
        var _id = pID;

        var element = document.getElementById(_id);
        var player = element ? element.svgatorPlayer : {};

        if (player.play) {
            player.play();
        }
    }
}

$(window).load(function () {
   Reveals.init();
});
